import { render, staticRenderFns } from "./AdmEditTxt.vue?vue&type=template&id=5b0b09da&scoped=true&"
import script from "./AdmEditTxt.vue?vue&type=script&lang=js&"
export * from "./AdmEditTxt.vue?vue&type=script&lang=js&"
import style0 from "./AdmEditTxt.vue?vue&type=style&index=0&id=5b0b09da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b09da",
  null
  
)

export default component.exports